'use client';

export default function Toolbar({ onRefresh, onScrape, lastScrapedAt, scraping, nodeCount, edgeCount }) {
  return (
    <header className="h-14 shrink-0 border-b border-graviome-border bg-graviome-panel flex items-center px-4 gap-4">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-graviome-blue to-graviome-amber flex items-center justify-center text-graviome-bg font-bold text-sm">
          G
        </div>
        <h1 className="text-lg font-semibold tracking-tight">Graviome</h1>
        <span className="text-xs text-graviome-muted font-mono hidden md:inline">mention network</span>
      </div>

      <div className="flex-1" />

      <div className="text-xs font-mono text-graviome-muted hidden md:flex gap-4">
        <span>{nodeCount} nodes</span>
        <span>{edgeCount} edges</span>
        {lastScrapedAt && <span>last: {new Date(lastScrapedAt).toLocaleString()}</span>}
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={onRefresh}
          className="text-xs px-3 py-1.5 rounded border border-graviome-border text-graviome-fg hover:border-graviome-blue hover:text-graviome-blue transition font-mono"
        >
          refresh
        </button>
        <button
          onClick={onScrape}
          disabled={scraping}
          className="text-xs px-3 py-1.5 rounded border border-graviome-blue bg-graviome-blue/10 text-graviome-blue hover:bg-graviome-blue/20 disabled:opacity-50 transition font-mono"
        >
          {scraping ? 'scraping...' : 'trigger scrape'}
        </button>
        <a
          href="/api/export/json"
          className="text-xs px-3 py-1.5 rounded border border-graviome-border text-graviome-muted hover:text-graviome-fg transition font-mono"
        >
          export json
        </a>
        <a
          href="/api/export/csv"
          className="text-xs px-3 py-1.5 rounded border border-graviome-border text-graviome-muted hover:text-graviome-fg transition font-mono"
        >
          export csv
        </a>
      </div>
    </header>
  );
}
